import React from 'react';
import { DemoExample, DemoPage, DemoPageSection } from './common/DemoLayout';

export const FontStylesDemo: React.FC = () => {
    return (
        <DemoPage title='Font Styles :'>
            <DemoPageSection title='Headers'>
                <h1>Header 1</h1>
                <h2>Header 2</h2>
                <h3>Header 3</h3>
                <h4>Header 4</h4>
                <h5>Header 5</h5>
                <h6>Header 6</h6>
            </DemoPageSection>
            <DemoPageSection title='Text'>
                <DemoExample>Body Text</DemoExample>
                <DemoExample>
                    <span className='secondaryText'>Secondary Text</span>
                </DemoExample>
                <DemoExample>
                    <span className='greenText'>Green Text</span>
                </DemoExample>
            </DemoPageSection>
        </DemoPage>
    );
};
